import clsx from "clsx";
import { useT } from "../i18n";

export type AccessSource = "rule" | "request" | "manual" | "inherited" | "import" | "external";
export const ACCESS_SOURCES: AccessSource[] = ["rule", "request", "manual", "inherited", "import", "external"];

/** Where access came from (§2.4). Neutral, radius 4: it explains, it does not alarm. */
export function SourceChip({ source, className, children }: { source: AccessSource | string; className?: string; children?: React.ReactNode }) {
  const t = useT();
  const label = children ?? t(`source.${source}`);
  return (
    <span className={clsx("inline-flex h-[22px] items-center whitespace-nowrap rounded-tag border border-line bg-surface-2 px-[7px] text-xs font-medium text-fg-2", className)}>
      {label}
    </span>
  );
}
